import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
import { showNotification, NOTIFICATION_TYPE } from '@thinknet-gmbh/platform-common-ui';

import { useCurrentMemberContext } from 'src/contexts';
import { GET_CURRENT_MEMBER } from 'src/hooks/accounts/get-current-member-account.hook';

const SET_GANTT_EMPLOYEES_ORDER = gql`
  mutation setGanttEmployeesOrder($ganttId: String!, $employeeGanttOrderIds: [String!]!) {
    setGanttEmployeesOrder(ganttId: $ganttId, employeeGanttOrderIds: $employeeGanttOrderIds) {
      _id
    }
  }
`;

export const useSetGanttEmployeesOrder = () => {
  const { t: globalExceptionsT } = useTranslation('common', { keyPrefix: 'exceptions' });
  const [setGanttEmployeesOrder] = useMutation(SET_GANTT_EMPLOYEES_ORDER, {
    refetchQueries: [GET_CURRENT_MEMBER],
  });
  const { ganttId } = useCurrentMemberContext();

  return (employeeGanttOrderIds: any) =>
    setGanttEmployeesOrder({
      variables: {
        ganttId,
        employeeGanttOrderIds,
      },
      onError: (error: any) =>
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.error,
          message: globalExceptionsT('internalError'),
          ...(error && { description: error.message || error.errorMessage }),
        }),
    });
};
